





























































import { defineComponent, ref, computed } from '@vue/composition-api';
import { NO_LIMIT } from '@tt4b/ttam-enums';
import TtamTargetSummary from '@/components/common/target-summary/index.vue';
import ALink from '@/components/common/a-link/a-link.vue';

const name = 'ttam-saved-audience-create-dialog';
export default defineComponent({
  name,
  components: {
    TtamTargetSummary,
    ALink,
  },
  props: {
    detailData: {
      type: Object,
      default: () => ({}),
    },
    learnMoreHref: {
      type: String,
      default: '',
    },
    isSubmitLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const dialogVisible = ref(false);
    const isNoLimitSettingVisible = ref(false);
    const formData = ref({
      name: '',
    });
    const isDisableSaveButton = computed(() => !formData.value.name);

    function handleClickViewAll() {
      isNoLimitSettingVisible.value = !isNoLimitSettingVisible.value;
    }

    function handleCloseDialog() {
      dialogVisible.value = false;
      isNoLimitSettingVisible.value = false;
      formData.value.name = '';
    }

    function handleConfirmSave() {
      emit('save', { savedAudienceName: formData.value.name });
    }

    return {
      name,
      dialogVisible,
      isDisableSaveButton,
      formData,
      handleClickViewAll,
      NO_LIMIT,
      isNoLimitSettingVisible,
      handleCloseDialog,
      handleConfirmSave,
    };
  },
});
